function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
  fill: "#F05B3A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6194 18.1569C10.6194 18.5314 10.9229 18.8349 11.2974 18.8349H20.8596C21.2341 18.8349 21.5376 18.5314 21.5376 18.1569V17.5256H10.6194V18.1569Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.8298 19.4651C11.8298 19.8395 12.1334 20.143 12.5078 20.143H19.6494C20.0238 20.143 20.3274 19.8395 20.3274 19.4651V18.8349H11.8298V19.4651Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.71226 8.19942C9.51847 8.32421 9.40137 8.53892 9.40137 8.76941V16.8475C9.40137 17.222 9.7049 17.5255 10.0793 17.5255H22.0781C22.4525 17.5255 22.7561 17.2219 22.7561 16.8475L22.7559 8.76928C22.7559 8.5388 22.6388 8.3241 22.445 8.19931L16.4459 4.33582C16.2224 4.19185 15.9353 4.19185 15.7118 4.33581L9.71226 8.19942Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.6012 9.06805C21.8543 8.90779 21.8532 8.53815 21.5991 8.37939L16.297 5.06643C16.1641 4.9834 15.9953 4.98407 15.8631 5.06817L10.6206 8.40278C10.3694 8.56259 10.3693 8.92929 10.6205 9.08918L15.8617 12.4252C15.9946 12.5099 16.1645 12.5101 16.2977 12.4258L21.6012 9.06805Z",
  fill: "#F05B3A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0682 29.0806C16.0682 29.0806 17.2087 28.3105 18.1224 27.0473C18.5836 26.4101 18.9867 25.6474 19.1563 24.7943C19.6623 22.2519 18.1443 21.0169 16.0682 21.0169C13.9914 21.0169 12.4736 22.2519 12.9792 24.7943C13.4854 27.3373 16.0682 29.0806 16.0682 29.0806Z",
  fill: "#FFE600"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1062 25.9615C16.1062 25.9615 14.701 25.01 14.4261 23.6218C14.1508 22.2332 14.9764 21.5593 16.1062 21.5593C17.2355 21.5593 18.0614 22.2332 17.7859 23.6218C17.5108 25.01 16.1062 25.9615 16.1062 25.9615Z",
  fill: "#F05B3A"
});

function SvgYammLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYammLogotype);
export default __webpack_public_path__ + "static/media/yamm-logotype.5d00641a.svg";
export { ForwardRef as ReactComponent };